/**
 * i18n PT-BR para o sistema de Facetas (PBI 79319 — Camada 2).
 *
 * Convenção registrada no plano:
 *   - PT-BR: UI/labels/mensagens ("Facetas", "Nova faceta", "Editar faceta")
 *   - EN: código, API, JSON keys, identificadores de banco
 */
export default {
  title: 'Facetas',
  description:
    'Vocabulário controlado para classificar documentos e reuniões. Os filtros do chat usam essas Facetas para refinar a busca.',
  add: 'Nova faceta',
  edit: 'Editar faceta',
  delete: 'Excluir',
  enable: 'Ativar',
  disable: 'Desativar',
  seedDefaults: 'Restaurar conjunto padrão',
  empty: 'Nenhuma faceta cadastrada ainda.',
  selectorPlaceholder: 'Selecione facetas',
  selectorEmpty: 'Nenhuma faceta disponível para esta organização.',
  fields: {
    name: 'Dimensão',
    nameHelp: 'Nome em inglês, lowercase, sem espaços (ex: type, format).',
    value: 'Valor',
    valueHelp: 'Valor em inglês, kebab-case (ex: meeting, release-note).',
    labelName: 'Rótulo da dimensão',
    labelValue: 'Rótulo do valor',
    parent: 'Faceta pai (opcional)',
    parentHelp: 'Hierarquia opcional. Mantém a faceta como filha de outra.',
    isActive: 'Ativa',
    none: 'Nenhuma',
  },
  confirmDelete: {
    title: 'Excluir faceta?',
    description:
      'Esta ação remove a faceta permanentemente. Se a faceta estiver em uso por documentos existentes, prefira desativá-la.',
  },
  errors: {
    nameRequired: 'Dimensão é obrigatória.',
    valueRequired: 'Valor é obrigatório.',
    invalidFormat: 'Use lowercase e kebab-case (apenas letras, números e hífens).',
    generic: 'Falha ao salvar a faceta.',
    atLeastOneRequiredTitle: 'Faceta obrigatória',
    atLeastOneRequiredDescription: 'Selecione ao menos uma faceta antes de enviar.',
  },
  success: {
    created: 'Faceta criada.',
    updated: 'Faceta atualizada.',
    deleted: 'Faceta excluída.',
    seeded: 'Conjunto padrão restaurado.',
  },
  // Labels traduzidos para os defaults do sistema (apenas display).
  // Slugs (name/value) ficam em inglês no banco; aqui é só apresentação.
  labels: {
    type: 'Tipo',
    format: 'Formato',
    status: 'Status',
    values: {
      // type — top-level
      meeting: 'Reunião',
      document: 'Documento',
      decision: 'Decisão',
      announcement: 'Comunicado',
      message: 'Mensagem',
      prompt: 'Prompt',
      // type — filhos de document
      study: 'Estudo',
      requirement: 'Requisito',
      report: 'Relatório',
      proposal: 'Proposta',
      technical: 'Documento Técnico',
      rfp: 'RFP',
      rfi: 'RFI',
      training: 'Treinamento',
      // type — filhos de announcement
      'release-note': 'Release Note',
      // format
      summary: 'Resumo',
      full: 'Completo',
      transcription: 'Transcrição',
      outline: 'Esboço',
      // status
      draft: 'Rascunho',
      approved: 'Aprovado',
      archived: 'Arquivado',
    } as Record<string, string>,
  },
};
